module.exports = __webpack_public_path__ + "static/img/ding38.b5191de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ding38.png
// module id = SP2Q
// module chunks = 0